/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORTS : REPORT HELPERS : STYLES --------------- ++++++++++ */
export default theme => ({
    reporthelpers: {
        background: '#fff',
        position: 'sticky',
        top: '0',
        left: '0',
        zIndex: '2',

        paddingTop: pxToEm(15),
        marginTop: pxToEm(-15),
        marginBottom: pxToEm(25),

        display: 'flex',
        justifyContent: 'space-between',
        '& .name-backtoreports': {
            // animate in
            opacity: '0',
            animationName: 'fadeInLeft',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s'
        },
        '& .datalastupdated': {
            // animate in
            opacity: '0',
            animationName: 'fadeInRight',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s'
        }
    }
})